<template>
  <div>
    <div
      class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="row">
        <h1 class="h2 text-muted">
          MAPPING ENGINE / OUTBOUND RULESETS / {{ head_ruleset_name }}
        </h1>
      </div>
      <div class="row" style="justify-content: flex-end;">
        <div class="col-2">
          <button
            type="button"
            class="btn btn-danger"
            id="disbut"
            data-bs-toggle="modal"
            data-bs-target="#removeModal"
          >
            Remove
          </button>
        </div>
        <div class="col-2">
          <button
            type="button"
            class="btn btn-primary"
            id="savebut"
            @click="editRuleset"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
    <!-- Remove Ruleset Modal -->
    <div
      class="modal fade"
      id="removeModal"
      tabindex="-1"
      aria-labelledby="removeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove Ruleset
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: This action cannot be un-done!
              </div>
            </div>
            <div class="row mb-3">
              <label for="confirmDelete" class="col-sm-8 col-form-label"
                >Are you sure you want to remove this ruleset? (Type yes to
                confirm)</label
              >
              <div class="col-sm-4">
                <input
                  class="form-control"
                  id="confirmDelete"
                  v-model="confirmDelete"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="discard"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      id="alertRuleset"
      v-if="updateRulesetError"
      class="alert alert-danger"
      role="alert"
    >
      Error: {{ updateRulesetReason }}
    </div>
    <form class="row g-3">
      <div class="col-md-4">
        <label class="form-label">Ruleset Name</label>
        <input
          type="text"
          class="form-control"
          id="rulesetName"
          v-model="ruleset_name"
          disabled
        />
      </div>
      <div class="col-md-3">
        <label class="form-label">Calculator</label>
        <select
          class="form-select"
          id="calculatorName"
          v-model="calculator_id"
          @change="getInsurer"
          disabled
        >
          <option
            v-for="calculator in calculators"
            v-bind:value="calculator.calculator_id"
            :key="calculator.calculator_id"
          >
            {{ calculator.calculator_name }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">Insurer</label>
        <select
          class="form-select"
          id="insurerName"
          v-model="insurer_id"
          disabled
          @change="getCalculators"
        >
          <option
            v-for="insurer in insurers"
            v-bind:value="insurer.insurer_id"
            :key="insurer.insurer_id"
          >
            {{ insurer.insurer_name }}
          </option>
        </select>
      </div>
      <div class="col-md-1">
        <div class="form-group">
          <label>
            Active
          </label>
          <br />
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              style="margin-top: 1.2em;"
              v-model="active"
              @change="activate"
            />
          </div>
        </div>
      </div>
      <div class="col-md-1" style="align-self: flex-end;">
        <button type="button" class="btn btn-secondary" @click="enableEdit">
          Edit
        </button>
      </div>
    </form>
    <!-- Activate Ruleset Modal -->
    <div
      class="modal fade"
      id="activateModal"
      tabindex="-1"
      aria-labelledby="activateModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Activate Ruleset</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="activated ? null : (active = false)"
            ></button>
          </div>
          <div class="modal-body" v-if="activated">
            Ruleset has been successfully activated.
          </div>
          <div class="modal-body" v-else>
            Another ruleset for this calculator and insurer is already active.
            Are you sure you want to switch?
          </div>
          <div class="modal-footer" v-if="activated">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Done
            </button>
          </div>
          <div class="modal-footer" v-else>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="active = false"
            >
              No
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="forceActivate"
              data-bs-dismiss="modal"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Force Update Ruleset Modal -->
    <div
      class="modal fade"
      id="forceUpdateModal"
      tabindex="-1"
      aria-labelledby="forceUpdateModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Activate Ruleset</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            Another ruleset for this calculator and insurer is already active.
            Are you sure you want to switch?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              No
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="
                forceActive = true;
                editRuleset();
              "
              data-bs-dismiss="modal"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Deactivate Ruleset Modal -->
    <div
      class="modal fade"
      id="deactivateModal"
      tabindex="-1"
      aria-labelledby="deactivateModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Deactivate Ruleset
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            Ruleset has been successfully deactivated.
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
    <form class="row g-3 mt-3 px-3">
      <div class="col-md-1"></div>
      <div class="col-md-1">
        <h6>#</h6>
      </div>
      <div class="col-md-2">
        <h6>Rule Type</h6>
      </div>
      <div class="col-md-3">
        <h6>Sources</h6>
      </div>
      <div class="col-md-3">
        <h6>Output/Result</h6>
      </div>
    </form>
    <div v-if="initialLoader" class="spinner-border text-primary" />
    <div v-else class="accordion accordion-flush" id="accordionFlushExample">
      <div
        class="accordion-item"
        v-for="(rule, index) in rules"
        :key="rule.sort"
      >
        <div
          :id="'addRuleAbove' + rule.sort"
          class="accordion-collapse collapse mt-3 px-3"
          aria-labelledby="flush-headingOne"
          data-bs-parent="#accordionFlushExample"
        >
          <div v-if="error" class="alert alert-danger" role="alert">
            Error: {{ reason }}
          </div>
          <div class="row">
            <div class="col-md-3">
              Source(s)<br />
              <table class="table table-sm col-md-3" id="sourceTable">
                <colgroup>
                  <col span="1" style="width: 10%;" />
                  <col span="1" style="width: 45%;" />
                  <col span="1" style="width: 45%;" />
                </colgroup>
                <thead>
                  <tr>
                    <th>#</th>
                    <th scope="col">Field</th>
                    <th scope="col">Test Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(source,
                    aboveSrcIndex) in renderSelectedSourceFields"
                    :key="source"
                  >
                    <td
                      :id="
                        'countAbove' +
                          source.replace(/[^a-zA-Z0-9]/g, '') +
                          rule.rule_id
                      "
                    >
                      {{ alphaCounter[aboveSrcIndex] }}
                    </td>
                    <td
                      style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
                    >
                      {{ source }}
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        style="width: -webkit-fill-available;"
                        :id="
                          'fieldValueAbove' +
                            source.replace(/[^a-zA-Z0-9]/g, '') +
                            rule.rule_id
                        "
                        v-on:input="
                          debounceFieldValueAbove(source, rule.rule_id)
                        "
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                type="button"
                class="btn btn-secondary btn-sm mb-3"
                data-bs-toggle="modal"
                data-bs-target="#addSourceFieldModal"
                @click="getOutboundFields"
              >
                Add Source Field
              </button>
            </div>
            <div class="col-md-3">
              <label for="customFunction" class="form-label">Function</label>

              <input
                v-model="functionExp"
                class="form-control"
                v-on:input="debounceMethodAbove"
                placeholder="Leave Blank for Passthru"
              />

              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#functionsHelp"
                style="font-size: x-small;"
                >Supported Functions Help</a
              >
            </div>
            <div class="col-md-3">
              Calculated Value
              <div style="display:flex;">
                <div class="col-8 px-1">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="calculatedValue"
                    disabled
                  />
                </div>
                <div class="col-4">
                  <div
                    v-if="executed === 'loading'"
                    class="spinner-border text-danger spinner-border-sm"
                  />
                  <span v-else-if="executed" class="badge bg-success"
                    >Success</span
                  >
                  <span v-else class="badge bg-danger">Failed</span>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              Output
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="calculator"
                  value="mapped"
                  v-model="output"
                />
                <label class="form-check-label" for="calculator">
                  Outbound Result Field
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="custom"
                  value="custom"
                  v-model="output"
                />
                <label class="form-check-label" for="custom">
                  Custom Field Value
                </label>
              </div>
              <select
                class="form-select"
                v-model="newSelectedCalculatorField"
                v-if="output === 'mapped'"
              >
                <option
                  v-for="field in calculatorFields"
                  v-bind:value="field.coverName"
                  :key="field.coverName"
                >
                  {{ field.coverName }}
                </option>
              </select>
              <input
                type="text"
                class="form-control"
                v-else-if="output === 'custom'"
                v-model="newSelectedCustomField"
              />
            </div>
          </div>
          <div class="form-group mt-3 mb-3" style="text-align:right;">
            <button
              class="btn btn-secondary"
              type="button"
              @click="cancelAddRuleAbove(rule.sort)"
            >
              Cancel
            </button>
            <div class="divider" />
            <button
              class="btn btn-primary"
              type="button"
              @click="addRuleAbove(rule.sort, 'above')"
            >
              Save Changes
            </button>
          </div>
        </div>
        <div class="accordion-header" :id="'ugh' + rule.rule_id">
          <div class="d-flex">
            <div class="col-md-1" style="align-self: center;">
              <button
                type="button"
                class="btn btn-light btn-sm"
                @click="up(index)"
                :disabled="rule.sort == 1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-compact-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z"
                  />
                </svg>
              </button>
              <button
                type="button"
                class="btn btn-light btn-sm"
                @click="down(index)"
                :disabled="rules.indexOf(rule) == rules.length - 1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-compact-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"
                  />
                </svg>
              </button>
            </div>
            <button
              class="accordion-button collapsed"
              :id="'accordion-header' + rule.rule_id"
              type="button"
              data-bs-toggle="collapse"
              :data-bs-target="'#collapse' + rule.rule_id"
              @click2="trial(rule.rule_id, rule.sort)"
              @click="openEditRule(rule, index)"
            >
              <div class="col-md-1" style="width: 9%;">{{ rule.sort }}</div>
              <div
                class="col-md-2"
                style="width: 19.5%;"
                v-if="rule.rule_data.function"
              >
                Calculated
              </div>
              <div class="col-md-2" style="width: 19.5%;" v-else>
                Passthrough
              </div>
              <div class="col-md-3" style="width: 30%;">
                <div
                  v-for="source in rule.source_fields"
                  :key="source"
                  style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 5%;"
                >
                  {{ source }}
                </div>
              </div>
              <div
                v-if="rule.output_type === 'mapped'"
                style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
              >
                {{ rule.mapped_param }}
              </div>
              <div
                v-else-if="rule.output_type === 'custom'"
                style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
              >
                {{ rule.custom_field }}
              </div>
            </button>
            <div class="btn-group dropdown" style="align-self: center;">
              <button
                type="button"
                class="btn btn-light btn-sm"
                data-bs-toggle="dropdown"
                :id="'btn' + rule.rule_id"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-three-dots-vertical"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                  />
                </svg>
              </button>
              <ul
                class="dropdown-menu"
                role="menu"
                aria-labelledby="dropdownMenuButton1"
                :id="'dropdown' + rule.rule_id"
              >
                <li>
                  <button
                    class="dropdown-item"
                    data-bs-toggle="modal"
                    :data-bs-target="'#removeRuleModal' + rule.rule_id"
                  >
                    Remove this rule
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    data-bs-toggle="modal"
                    :data-bs-target="'#copyRuleModal' + rule.rule_id"
                    @click="getRulesets"
                  >
                    Copy this rule
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#addRuleAbove' + rule.sort"
                    @click="trial(0, 0)"
                  >
                    Insert Above
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#addRuleBelow' + rule.sort"
                    @click="trial(0, 0)"
                  >
                    Insert Below
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          :id="'collapse' + rule.rule_id"
          class="accordion-collapse collapse px-3"
          aria-labelledby="flush-headingOne"
          data-bs-parent="#accordionFlushExample"
        >
          <div v-if="error" class="alert alert-danger" role="alert">
            Error: {{ reason }}
          </div>
          <div class="row">
            <div class="col-md-3">
              Source(s)<br />
              <table
                class="table table-sm col-md-3"
                style="width: 100%"
                id="sourceTable"
              >
                <colgroup>
                  <col span="1" style="width: 10%;" />
                  <col span="1" style="width: 45%;" />
                  <col span="1" style="width: 45%;" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Field</th>
                    <th scope="col">Test Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(source, editSrcIndex) in rule.source_fields"
                    :key="source"
                  >
                    <td
                      :id="
                        'count' +
                          source.replace(/[^a-zA-Z0-9]/g, '') +
                          rule.rule_id
                      "
                    >
                      {{ alphaCounter[editSrcIndex] }}
                    </td>
                    <td
                      style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
                    >
                      {{ source }}
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        :id="
                          'fieldValue' +
                            source.replace(/[^a-zA-Z0-9]/g, '') +
                            rule.rule_id
                        "
                        v-on:input="
                          debounceFieldValue(source, rule.sort, rule.rule_id)
                        "
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                data-bs-toggle="modal"
                :data-bs-target="'#sourceFieldModal' + rule.rule_id"
                @click="getOutboundFields"
              >
                Add Source Field
              </button>
            </div>
            <div class="col-md-3">
              <label for="customFunction" class="form-label">Function</label>

              <input
                v-model="rule.rule_data.function"
                class="form-control"
                v-on:input="debounceMethod(rule.sort)"
                placeholder="Leave Blank for Passthru"
              />

              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#functionsHelp"
                style="font-size: x-small;"
                >Supported Functions Help</a
              >
            </div>
            <div class="col-md-3">
              Calculated Value
              <div style="display:flex;">
                <div class="col-8 px-1">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="calculatedValue"
                    disabled
                  />
                </div>
                <div class="col-4">
                  <div
                    v-if="executed === 'loading'"
                    class="spinner-border text-danger spinner-border-sm"
                  />
                  <span v-else-if="executed" class="badge bg-success"
                    >Success</span
                  >
                  <span v-else class="badge bg-danger">Failure</span>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              Output
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="calculator"
                  value="mapped"
                  v-model="rule.output_type"
                />
                <label class="form-check-label" for="calculator">
                  Outbound Result Field
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="custom"
                  value="custom"
                  v-model="rule.output_type"
                />
                <label class="form-check-label" for="custom">
                  Custom Field Value
                </label>
              </div>
              <select
                class="form-select"
                v-model="rule.mapped_param"
                v-if="rule.output_type === 'mapped'"
              >
                <option
                  v-for="field in calculatorFields"
                  v-bind:value="field.coverName"
                  :key="field.coverName"
                >
                  {{ field.coverName }}
                </option>
              </select>
              <input
                type="text"
                class="form-control"
                v-else-if="rule.output_type === 'custom'"
                v-model="rule.custom_field"
              />
            </div>
          </div>
          <div class="form-group mb-3" style="text-align:right;">
            <button
              class="btn btn-secondary"
              type="button"
              @click="cancelUpdateRule(rule.rule_id, rule.sort)"
            >
              Cancel
            </button>
            <div class="divider" />
            <button
              class="btn btn-primary"
              type="button"
              @click="updateRule(rule.rule_id, rule.sort - 1)"
            >
              Save Changes
            </button>
          </div>
        </div>
        <div
          :id="'addRuleBelow' + rule.sort"
          class="accordion-collapse collapse mt-3 px-3"
          aria-labelledby="flush-headingOne"
          data-bs-parent="#accordionFlushExample"
        >
          <div v-if="error" class="alert alert-danger" role="alert">
            Error: {{ reason }}
          </div>
          <div class="row">
            <div class="col-md-3">
              Source(s)<br />
              <table class="table table-sm col-md-3" id="sourceTable">
                <colgroup>
                  <col span="1" style="width: 10%;" />
                  <col span="1" style="width: 45%;" />
                  <col span="1" style="width: 45%;" />
                </colgroup>
                <thead>
                  <tr>
                    <th>#</th>
                    <th scope="col">Field</th>
                    <th scope="col">Test Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(newSource,
                    belowSrcIndex) in renderSelectedSourceFields"
                    :key="newSource"
                  >
                    <td
                      :id="
                        'countBelow' +
                          newSource.replace(/[^a-zA-Z0-9]/g, '') +
                          rule.rule_id
                      "
                    >
                      {{ alphaCounter[belowSrcIndex] }}
                    </td>
                    <td
                      style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
                    >
                      {{ newSource }}
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        style="width: -webkit-fill-available;"
                        :id="
                          'fieldValueBelow' +
                            newSource.replace(/[^a-zA-Z0-9]/g, '') +
                            rule.rule_id
                        "
                        v-on:input="
                          debounceFieldValueBelow(newSource, rule.rule_id)
                        "
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                type="button"
                class="btn btn-secondary btn-sm mb-3"
                data-bs-toggle="modal"
                data-bs-target="#addSourceFieldModal"
                @click="getOutboundFields"
              >
                Add Source Field
              </button>
            </div>
            <div class="col-md-3">
              <label for="customFunction" class="form-label">Function</label>
              <!-- <input
                    v-model="functionExp"
                    class="form-control form-control-sm"
                    v-on:input="debounceMethodBelow"
                  /> -->

              <input
                v-model="functionExp"
                class="form-control"
                v-on:input="debounceMethodBelow"
                placeholder="Leave Blank for Passthru"
              />

              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#functionsHelp"
                style="font-size: x-small;"
                >Supported Functions Help</a
              >
            </div>
            <div class="col-md-3">
              Calculated Value
              <div style="display:flex;">
                <div class="col-8 px-1">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="calculatedValue"
                    disabled
                  />
                </div>
                <div class="col-4">
                  <div
                    v-if="executed === 'loading'"
                    class="spinner-border text-danger spinner-border-sm"
                  />
                  <span v-else-if="executed" class="badge bg-success"
                    >Success</span
                  >
                  <span v-else class="badge bg-danger">Failed</span>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              Output
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="calculator"
                  value="mapped"
                  v-model="output"
                />
                <label class="form-check-label" for="calculator">
                  Outbound Result Field
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="custom"
                  value="custom"
                  v-model="output"
                />
                <label class="form-check-label" for="custom">
                  Custom Field Value
                </label>
              </div>
              <select
                class="form-select"
                v-model="newSelectedCalculatorField"
                v-if="output === 'mapped'"
              >
                <option
                  v-for="field in calculatorFields"
                  v-bind:value="field.coverName"
                  :key="field.coverName"
                >
                  {{ field.coverName }}
                </option>
              </select>
              <input
                type="text"
                class="form-control"
                v-else-if="output === 'custom'"
                v-model="newSelectedCustomField"
              />
            </div>
          </div>
          <div class="form-group mt-3 mb-3" style="text-align:right;">
            <button
              class="btn btn-secondary"
              type="button"
              @click="cancelAddRuleBelow(rule.sort)"
            >
              Cancel
            </button>
            <div class="divider" />
            <button
              class="btn btn-primary"
              type="button"
              @click="addRuleAbove(rule.sort, 'below')"
            >
              Save Changes
            </button>
          </div>
        </div>
        <!-- Edit Source Modal -->
        <div
          v-if="sourceLoaderArr[index]"
          class="modal fade"
          :id="'sourceFieldModal' + rule.rule_id"
          tabindex="-1"
          aria-labelledby="sourceFieldModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content" style="min-height: inherit;">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Outbound Field Manager
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  @click="
                    searchQuery = '';
                    typeFilter = '';
                  "
                ></button>
              </div>
              <div class="modal-body">
                <div class="">
                  <div class="row g-3 d-flex">
                    <div class="col-sm-6">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search by field name or description press Enter to execute..."
                        v-model.lazy="searchQuery"
                        @keypress.enter="debounceInput"
                        v-on:blur="debounceInput"
                      />
                    </div>
                    <div class="col-sm-2" style="align-self: center;">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="inlineCheckbox1"
                          value="Calculator Output"
                          v-model="typeFilter"
                          v-on:input="debounceInput"
                        />
                        <label class="form-check-label" for="inlineCheckbox1"
                          >Calculator Output</label
                        >
                      </div>
                    </div>
                    <div class="col-sm-2" style="align-self: center;">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="inlineCheckbox1"
                          value="Mapped outputs"
                          v-model="typeFilter"
                          v-on:input="debounceInput"
                        />
                        <label class="form-check-label" for="inlineCheckbox1"
                          >Mapped outputs</label
                        >
                      </div>
                    </div>
                    <div class="col-sm-2" style="text-align: center;">
                      <button
                        type="button"
                        class="btn"
                        style="padding: 0 0;"
                        @click="clearSearch"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-x-circle"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                          />
                          <path
                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="sourceLoader" class="spinner-border text-primary" />
                <div v-else class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">Field Name</th>
                        <th scope="col">Description</th>
                        <th scope="col">Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="field in resultQuery" :key="field.output_id">
                        <td>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="rule.source_fields"
                            v-bind:value="field.field_name"
                            :key="field.field_name"
                          />
                        </td>
                        <td>{{ field.field_name }}</td>
                        <td v-if="field.origin_type === 'Calculator Output'">
                          Data type is {{ field.type }}
                        </td>
                        <td v-else-if="field.origin_type === 'Mapped outputs'">
                          {{ field.description }}
                        </td>
                        <td>{{ field.origin_type }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                  @click="selectFields(rule.sort)"
                >
                  Select
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Remove Rule Modal -->
        <div
          class="modal fade"
          :id="'removeRuleModal' + rule.rule_id"
          tabindex="-1"
          aria-labelledby="removeRuleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Remove Rule
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  @click="confirmDeleteRule = ''"
                ></button>
              </div>
              <div class="modal-body">
                <div
                  class="alert alert-danger d-flex align-items-center"
                  role="alert"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                    viewBox="0 0 16 16"
                    role="img"
                    aria-label="Warning:"
                  >
                    <path
                      d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                    />
                  </svg>
                  <div>
                    Warning: This action cannot be un-done!
                  </div>
                </div>
                <div class="row mb-3">
                  <label for="confirmDeleteRule" class="col-sm-8 col-form-label"
                    >Are you sure you want to remove this rule? (Type yes to
                    confirm)</label
                  >
                  <div class="col-sm-4">
                    <input
                      class="form-control"
                      v-model="confirmDeleteRule"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                  @click="confirmDeleteRule = ''"
                >
                  Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                  @click="removeRule(rule.rule_id)"
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Copy Rule Modal -->
        <div
          class="modal fade"
          :id="'copyRuleModal' + rule.rule_id"
          tabindex="-1"
          aria-labelledby="copyRuleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  COPY RULE
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  @click="
                    copyType = '';
                    copyRuleset = '';
                  "
                ></button>
              </div>
              <div class="modal-body col-md-10" style="align-self: center;">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="start"
                    v-model="copyType"
                  />
                  <label class="form-check-label">
                    Copy to the Start of this Ruleset
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="end"
                    v-model="copyType"
                  />
                  <label class="form-check-label">
                    Copy to the End of this Ruleset
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="another"
                    v-model="copyType"
                  />
                  <label class="form-check-label">
                    Copy to another Ruleset
                  </label>
                </div>
                <div v-if="copyType === 'another'" class="col-md-8">
                  <select class="form-select mt-2 mb-2" v-model="copyRuleset">
                    <option
                      v-for="ruleset in rulesets"
                      v-bind:value="ruleset.ruleset_id"
                      :key="ruleset.ruleset_id"
                    >
                      {{ ruleset.mapping_ruleset_name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                  @click="copyRule(rule.rule_id)"
                >
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Source Modal -->
    <div
      class="modal fade"
      id="addSourceFieldModal"
      tabindex="-1"
      aria-labelledby="sourceFieldModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content" style="min-height: inherit;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Outbound Field Manager
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="
                searchQuery = '';
                typeFilter = '';
              "
            ></button>
          </div>
          <div class="modal-body">
            <div class="">
              <div class="row g-3 d-flex">
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search by field name or description22..."
                    v-model="searchQuery"
                    v-on:keyup.enter="debounceInput"
                  />
                </div>
                <div class="col-sm-2" style="align-self: center;">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="inlineCheckbox1"
                      value="Calculator Output"
                      v-model="typeFilter"
                      v-on:input="debounceInput"
                    />
                    <label class="form-check-label" for="inlineCheckbox1"
                      >Calculator Output</label
                    >
                  </div>
                </div>
                <div class="col-sm-2" style="align-self: center;">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="inlineCheckbox1"
                      value="Mapped outputs"
                      v-model="typeFilter"
                      v-on:input="debounceInput"
                    />
                    <label class="form-check-label" for="inlineCheckbox1"
                      >Mapped outputs</label
                    >
                  </div>
                </div>
                <div class="col-sm-2" style="text-align: center;">
                  <button
                    type="button"
                    class="btn"
                    style="padding: 0 0;"
                    @click="clearSearch"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-x-circle"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                      />
                      <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="sourceLoader" class="spinner-border text-primary" />
            <div v-else class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Field Name</th>
                    <th scope="col">Description</th>
                    <th scope="col">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="field in resultQuery" :key="field.output_id">
                    <td>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="newSelectedSourceFields"
                        v-bind:value="field.field_name"
                        :key="field.field_name"
                      />
                    </td>
                    <td>{{ field.field_name }}</td>
                    <td v-if="field.origin_type === 'Calculator Output'">
                      Data type is {{ field.type }}
                    </td>
                    <td v-else-if="field.origin_type === 'Mapped outputs'">
                      {{ field.description }}
                    </td>
                    <td>{{ field.origin_type }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="renderFields"
            >
              Select
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      id="addRuleEnd"
      class="accordion-collapse collapse mt-3 px-3"
      aria-labelledby="flush-headingOne"
      data-bs-parent="#accordionFlushExample"
    >
      <div v-if="error" class="alert alert-danger" role="alert">
        Error: {{ reason }}
      </div>
      <div class="row">
        <div class="col-md-3">
          <label class="form-check-label"> Source(s)</label>
          <table class="table table-sm col-md-3" id="sourceTable">
            <colgroup>
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 45%;" />
              <col span="1" style="width: 45%;" />
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th scope="col">Field</th>
                <th scope="col">Test Value</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(newSource, endSrcIndex) in renderSelectedSourceFields"
                :key="newSource"
              >
                <td :id="'countEnd' + newSource.replace(/[^a-zA-Z0-9]/g, '')">
                  {{ alphaCounter[endSrcIndex] }}
                </td>
                <td
                  style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
                >
                  {{ newSource }}
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    style="width: -webkit-fill-available;"
                    :id="
                      'fieldValueEnd' + newSource.replace(/[^a-zA-Z0-9]/g, '')
                    "
                    v-on:input="debounceFieldValueEnd(newSource)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <button
            type="button"
            class="btn btn-secondary btn-sm mb-3"
            data-bs-toggle="modal"
            data-bs-target="#addSourceFieldModal"
            @click="getOutboundFields"
          >
            Add Source Field
          </button>
        </div>
        <div class="col-md-3">
          <label for="customFunction" class="form-label">Function</label>

          <input
            v-model="functionExp"
            class="form-control"
            v-on:input="debounceMethodEnd"
            placeholder="Leave Blank for Passthru"
          />

          <a
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#functionsHelp"
            style="font-size: x-small;"
            >Supported Functions Help</a
          >
        </div>
        <div class="col-md-3">
          Calculated Value
          <div style="display:flex;">
            <div class="col-8 px-1">
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="calculatedValue"
                disabled
              />
            </div>
            <div class="col-4">
              <div
                v-if="executed === 'loading'"
                class="spinner-border text-danger spinner-border-sm"
              />
              <span v-else-if="executed" class="badge bg-success">Success</span>
              <span v-else class="badge bg-danger">Failed</span>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          Output
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="calculator"
              value="mapped"
              v-model="output"
            />
            <label class="form-check-label" for="calculator">
              Outbound Result Field
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="custom"
              value="custom"
              v-model="output"
            />
            <label class="form-check-label" for="custom">
              Custom Field Value
            </label>
          </div>
          <select
            class="form-select"
            v-model="newSelectedCalculatorField"
            v-if="output === 'mapped'"
          >
            <option
              v-for="field in calculatorFields"
              v-bind:value="field.coverName"
              :key="field.coverName"
            >
              {{ field.coverName }}
            </option>
          </select>
          <input
            type="text"
            class="form-control"
            v-else-if="output === 'custom'"
            v-model="newSelectedCustomField"
          />
        </div>
      </div>
      <div class="form-group mt-3 mb-3" style="text-align:right;">
        <button
          class="btn btn-secondary"
          type="button"
          @click="cancelAddRuleEnd"
        >
          Cancel
        </button>
        <div class="divider" />
        <button
          class="btn btn-primary"
          type="button"
          @click="addRuleAbove(0, 'end')"
        >
          Save Changes
        </button>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-secondary mb-3"
      data-bs-toggle="collapse"
      data-bs-target="#addRuleEnd"
      @click="trial(0, 0)"
    >
      Add Rule
    </button>
    <!-- Supported Functions Help Modal -->
    <div
      class="modal fade"
      id="functionsHelp"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Supported Functions Help
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            Note: You can pass Numeric value or any Source Field as the inputs
            for the functions <br /><br />All the Mathematical operations {+, -,
            /, *, ^, etc} will be processed based on BODMAS rule. i.e, In Order
            of Brackets &gt; Order(Power and Exponents) &gt;
            Division/Multiplication &gt; Addition/Substraction Eg:- A+B*C+D/E
            =&gt; A+(B*C)+(D/E) <br /><br />
            ROUND(&lt;value&gt;,&lt;decimals&gt;) <br />Eg:- ROUND(15.245,2)
            =&gt; 15.25<br />
            ROUND(A,B) {A and B are the source fields}<br /><br />
            ROUNDUP(&lt;value&gt;,&lt;decimals&gt;)<br />
            Eg:- ROUNDUP(17.833,1) =&gt; 17.9<br /><br />
            ROUNDDOWN(&lt;value&gt;,&lt;decimals&gt;)<br />
            Eg:- ROUNDDOWN(45.4589,3) =&gt; 45.458<br /><br />
            POWER(&lt;value&gt;,&lt;exponent&gt;) <br />Eg:- POWER(4,3) =&gt;
            64<br />
            POWER(A,5) <br /><br />AVERAGE(&lt;value1&gt;, &lt;value2&gt; ... )
            <br />Eg:- AVERAGE(8, 4, 6) =&gt; 6<br /><br />
            MIN(&lt;value1&gt;, &lt;value2&gt; ... )<br />
            Eg:- MIN(8,5,6,45) =&gt; 5 <br /><br />MAX(&lt;value1&gt;,
            &lt;value2&gt; ... )<br />
            Eg:- MAX(A,B,C) =&gt; will return maximum value between source
            fields A,B,C.<br /><br />
            SUM(&lt;value1&gt;, &lt;value2&gt; ... )<br />
            Eg:- SUM(A,B,15) <br /><br />ABS(&lt;value&gt;) <br />Eg:-
            ABS(-45.8) =&gt; 45.8<br /><br />
            IF(&lt;condition&gt;, &lt;output in case of true&gt;, &lt;output in
            case of false&gt;)<br />
            Eg:- IF(A&lt;=8, "1-8","8") =&gt; return "1-8" for A less than equal
            to 8 and "8" for greater than "8". Where A is the Input Source Field
            <br /><br />LN(&lt;value&gt;): To calculate Natural Logarithm of a
            Number<br />
            Eg:- LN(32) =&gt; 3.4657359027997265<br /><br />
            LOG(&lt;value&gt;, &lt;base&gt;): To calculate Logarithm of a Number
            for given base.<br />
            Eg:- LOG(32,2) =&gt; 4<br /><br />
            AND(&lt;condition1&gt;, &lt;condition2&gt; ....): Performs Logical
            AND operation between different condition and return True or
            False<br />
            Eg:- AND(A&gt;5, A&lt;50) =&gt; Depends on value of a the function
            will return True or False<br /><br />
            OR(&lt;condition1&gt;, &lt;condition2&gt; ....): Performs Logical
            AND operation between different condition and return True or False
            <br />Eg:- OR(A&gt;100, A&lt;50) =&gt; Depends on value of a the
            function will return True or False
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              id="functionsHelpbtn"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Ruleset Copied Toast -->
    <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11">
      <div
        class="toast hide align-items-center"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div class="d-flex">
          <div class="toast-body">Rule successfully copied!</div>
          <button
            type="button"
            class="btn-close me-2 m-auto"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../config";
import _ from "lodash";
import $ from "jquery";
export default {
  data() {
    return {
      head_ruleset_name: "",
      ruleset_name: "",
      calculators: [],
      calculator_name: "",
      calculator_id: "",
      insurers: [],
      insurer_name: "",
      insurer_id: "",
      outboundfields: [],
      searchQuery: "",
      resultQuery: [],
      typeFilter: "",
      confirmDelete: "",
      method: "",
      rules: [],
      openRuleIndex: 0,
      active: false,
      activated: false,
      fieldValues: {},
      calculatedValue: "",
      executed: false,
      output: null,
      calculatorFields: {},
      newSelectedSourceFields: [],
      renderSelectedSourceFields: [],
      newSelectedCalculatorField: null,
      newSelectedCustomField: null,
      confirmDeleteRule: "",
      alphaCounter: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "AA",
        "AB",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AH",
        "AI",
        "AJ",
        "AK",
        "AL",
        "AM",
        "AN",
        "AO",
        "AP",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AV",
        "AW",
        "AX",
        "AY",
        "AZ",
      ],
      functionType: "",
      functionExp: "",
      roundType: "donotround",
      roundDecimals: 0,
      selectedFunctionType: "",
      selectedFunctionExp: "",
      selectedRoundType: "donotround",
      selectedRoundDecimals: 0,
      rows: 0,
      rowsEdit: 0,
      expandedFunctionExp: "",
      copyType: "",
      copyRuleset: "",
      rulesets: [],
      tableMap: {},
      tableMapEdit: {},
      qualifyFunction: "",
      declineOn: "",
      declineMsg: "",
      referOnFail: false,
      referMsg: "",
      declined: "",
      tables: [],
      newLookupTable: "",
      accept: false,
      error: false,
      reason: "",
      updateRulesetError: false,
      updateRulesetReason: "",
      forceActive: false,
      initialLoader: true,
      sourceLoader: true,
      sourceLoaderArr: []
    };
  },
  methods: {
    async getOutboundFields() {
      // this.sourceLoader = true;
      // const requestOptions = {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   credentials: "include",
      //   body: JSON.stringify({
      //     data: {
      //       ruleset_id: this.$route.params.id,
      //     },
      //   }),
      // };
      // const response = await fetch(
      //   config.baseURL + "/get_all_req_mapping_fields",
      //   requestOptions
      // );
      // const data = await response.json();
      // console.log(data);
      if(this.outboundfields.length > 0){
        return
      }
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_all_req_mapping_mapped_fields",
        requestOptions
      );
      const data = await response.json();
      let outboundFields = JSON.parse(
        sessionStorage.getItem("req_mapped_fields")
      );
      outboundFields.push(...data);
      this.outboundfields = outboundFields;
      this.resultQuery = this.filterMap();
      this.sourceLoader = false;
    },
    callTry: _.debounce(function() {
      if (!_.isEmpty(this.fieldValues)) {
        this.ruleCheckABE();
        console.log(this.fieldValues);
      }
    }, 500),
    selectFields(sort) {
      // for (var field of this.rules[sort - 1].source_fields.values()) {
      //   $("#fieldValue" + field.replace(/[^a-zA-Z0-9]/g, "")).val("");
      // }
      // this.calculatedValue = "";
      // this.executed = false;
      const l = new Set(this.rules[sort - 1].source_fields);
      // var tableRows = Object.values(this.tableMapEdit);
      for (let prop of Object.keys(this.fieldValues)) {
        if (!l.has(prop)) {
          delete this.fieldValues[prop];
        }
      }
      Object.values(this.fieldValues).forEach((element, index) => {
        element[0] = this.alphaCounter[index];
        // console.log(this.alphaCounter);
      });
      console.log({ thissss: this.fieldValues });
      Object.values(this.tableMapEdit).forEach(function(row) {
        for (let prop of Object.keys(row)) {
          if (!l.has(prop) && prop != "output") {
            delete row[prop];
          }
        }
      });
      console.log(this.tableMapEdit);
      this.ruleCheck(sort - 1);
    },
    renderFields() {
      // for (var field of this.renderSelectedSourceFields.values()) {
      //   $("#fieldValueEnd" + field.replace(/[^a-zA-Z0-9]/g, "")).val("");
      // }
      this.renderSelectedSourceFields = [];
      this.renderSelectedSourceFields = this.newSelectedSourceFields;
      const l = new Set(this.renderSelectedSourceFields);
      for (let prop of Object.keys(this.fieldValues)) {
        if (!l.has(prop)) {
          delete this.fieldValues[prop];
        }
      }
      console.log({ thissss: this.renderSelectedSourceFields });

      let sortedFieldValuesMap = new Map();
      this.renderSelectedSourceFields.forEach((key) =>
        sortedFieldValuesMap.set(key, this.fieldValues[key])
      );
      const sortedFieldValues = Object.assign(sortedFieldValuesMap, {});
      console.log({ thispt2: sortedFieldValues });

      // const fieldKeys = Object.keys(this.fieldValues).sort((a, b) => {
      //   return (
      //     this.renderSelectedSourceFields.indexOf(a) -
      //     this.renderSelectedSourceFields.indexOf(b)
      //   );
      // });
      // console.log({ thispt2: fieldKeys });

      Object.values(this.fieldValues).forEach((element, index) => {
        element[0] = this.alphaCounter[index];
        // console.log(this.alphaCounter);
      });
      var tableRows = Object.values(this.tableMap);
      tableRows.forEach(function(row) {
        for (let prop of Object.keys(row)) {
          if (!l.has(prop) && prop != "output") {
            delete row[prop];
          }
        }
      });
    },
    openEditRule: function(rule, index){
      // this.openRuleIndex = index
      this.sourceLoaderArr = this.rules.map(x => { if(x) return false});
      this.sourceLoaderArr[index] = true
      this.rule = rule;
      this.trial(rule.rule_id, rule.sort);
    },
    trial(rule_id, sort) {
      let nl = document.querySelectorAll('[id^="accordion-header"]');
      var arr = [];
      for (var i = nl.length; i--; arr.unshift(nl[i].id));
      arr.forEach((element) => {
        $("#" + element).css({ visibility: "visible", height: "auto" });
      });
      this.getDeets();
      this.fieldValues = {};

      this.calculatedValue = "";
      this.executed = false;
      this.declined = "";
      this.accept = false;

      if (rule_id !== 0 && sort !== 0) {
        if ("test_values" in this.rules[sort - 1]["rule_data"]) {
          this.fieldValues = this.rules[sort - 1]["rule_data"]["test_values"];
        }
        $("#addRuleEnd").collapse("hide");
        this.clearUpdate(rule_id, sort - 1);
        $("#accordion-header" + rule_id).css({
          visibility: "hidden",
          height: "60px",
        });
        $("#collapse" + rule_id).collapse("show");
        if (this.rules[sort - 1].rule_type === "map") {
          this.tableMapEdit = Object.assign(
            {},
            this.rules[sort - 1].rule_data.table_map
          );
          this.rowsEdit = this.rules[sort - 1].rule_data.table_map.length;
        }
        if (!_.isEmpty(this.fieldValues)) {
          Object.entries(this.fieldValues).map((entry) => {
            $(
              "#fieldValue" + entry[0].replace(/[^a-zA-Z0-9]/g, "") + rule_id
            ).val(entry[1][1]);
          });
          this.ruleCheck(sort - 1);
        }
      }
    },
    debounceFieldValueAbove(source, id) {
      this.fieldValues[`${source}`] = [
        $("#countAbove" + source.replace(/[^a-zA-Z0-9]/g, "") + id)
          .text()
          .trim(),
        $("#fieldValueAbove" + source.replace(/[^a-zA-Z0-9]/g, "") + id).val(),
      ];
      const l = new Set(this.renderSelectedSourceFields);
      for (let prop of Object.keys(this.fieldValues)) {
        if (!l.has(prop)) {
          delete this.fieldValues[prop];
        }
      }
      console.log(this.fieldValues);

      this.callTry();
    },
    debounceMethodAbove: _.debounce(function() {
      if (!_.isEmpty(this.fieldValues)) {
        this.ruleCheckABE();
        console.log(this.fieldValues);
      }
    }, 500),
    debounceFieldValueBelow: _.debounce(function(source, id) {
      this.fieldValues[`${source}`] = [
        $("#countBelow" + source.replace(/[^a-zA-Z0-9]/g, "") + id)
          .text()
          .trim(),
        $("#fieldValueBelow" + source.replace(/[^a-zA-Z0-9]/g, "") + id).val(),
      ];
      const l = new Set(this.renderSelectedSourceFields);
      for (let prop of Object.keys(this.fieldValues)) {
        if (!l.has(prop)) {
          delete this.fieldValues[prop];
        }
      }
      this.ruleCheckABE();
    }, 500),
    debounceMethodBelow: _.debounce(function() {
      if (!_.isEmpty(this.fieldValues)) {
        this.ruleCheckABE();
        console.log(this.fieldValues);
      }
    }, 500),
    async ruleCheckABE() {
      this.executed = "loading";
      var ruleData = null;

      ruleData = {
        function: this.functionExp,
      };
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
            calculator_id: this.calculator_id,
            insurer_id: this.insurer_id,
            rule_type: this.method,
            rule_data: ruleData,
            source_fields: this.fieldValues,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/execute_mapping_rule_check",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      this.calculatedValue = data["Value"];
      this.executed = data["Executed"];
      this.declined = data["decline"];
      this.accept = data["accept"];
    },
    debounceFieldValueEnd: _.debounce(function(source) {
      console.log(source);
      console.log(this.newSelectedSourceFields);
      this.fieldValues[`${source}`] = [
        $("#countEnd" + source.replace(/[^a-zA-Z0-9]/g, ""))
          .text()
          .trim(),
        $("#fieldValueEnd" + source.replace(/[^a-zA-Z0-9]/g, "")).val(),
      ];
      const l = new Set(this.renderSelectedSourceFields);
      for (let prop of Object.keys(this.fieldValues)) {
        if (!l.has(prop)) {
          delete this.fieldValues[prop];
        }
      }

      console.log(this.fieldValues);

      this.ruleCheckABE();
    }, 500),
    debounceMethodEnd: _.debounce(function() {
      if (!_.isEmpty(this.fieldValues)) {
        this.ruleCheckABE();
        console.log(this.fieldValues);
      }
    }, 500),
    debounceFieldValue: _.debounce(function(source, sort, id) {
      const l = new Set(this.rules[sort - 1].source_fields);
      for (let prop of Object.keys(this.fieldValues)) {
        if (!l.has(prop)) {
          delete this.fieldValues[prop];
        }
      }
      this.fieldValues[`${source}`] = [
        $("#count" + source.replace(/[^a-zA-Z0-9]/g, "") + id)
          .text()
          .trim(),
        $("#fieldValue" + source.replace(/[^a-zA-Z0-9]/g, "") + id).val(),
      ];
      console.log(this.fieldValues);

      this.ruleCheck(sort - 1);
    }, 500),
    debounceMethod: _.debounce(function(sort) {
      if (!_.isEmpty(this.fieldValues)) {
        this.ruleCheck(sort - 1);
        console.log(this.fieldValues);
      }
    }, 500),
    async ruleCheck(sort) {
      console.log(this.rules[sort].source_fields);
      this.executed = "loading";
      var ruleData = null;

      ruleData = {
        function: this.rules[sort].rule_data.function,
      };
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
            calculator_id: this.calculator_id,
            insurer_id: this.insurer_id,
            rule_type: this.rules[sort].rule_type,
            rule_data: ruleData,
            source_fields: this.fieldValues,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/execute_mapping_rule_check",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      this.calculatedValue = data["Value"];
      this.executed = data["Executed"];
      this.declined = data["decline"];
      this.accept = data["accept"];
    },
    debounceInput: _.debounce(function(e) {
      console.log(e.target.value);
      this.sourceLoader = true;
      this.resultQuery = this.filterMap();
      setTimeout(() => {
        this.sourceLoader = false;  
      }, 150);
    }, 50),
    filterMap() {
      if (this.searchQuery == '' && this.typeFilter == ''){
        return this.outboundfields;
      }
      if (this.searchQuery || this.typeFilter) {
        return this.outboundfields.filter((field) => {
          return (
            (this.searchQuery
              .toLowerCase()
              .split(" ")
              .every((v) => field.field_name.toLowerCase().includes(v)) ||
              this.searchQuery
                .toLowerCase()
                .split(" ")
                .every((v) => field.field_name.includes(v)) ||
              this.searchQuery
                .split(" ")
                .every((v) =>
                  (field.description ? field.description : "")
                    .toLowerCase()
                    .includes(v)
                )) &&
            this.typeFilter
              .split(" ")
              .every((v) => field.origin_type.includes(v))
          );
        });
      } else {
        return this.outboundfields;
      }
    },
    async addRuleAbove(sort, pos) {
      var ruleData = null;

      ruleData = {
        function: this.functionExp,
        test_values: this.fieldValues,
      };

      var sources = {};
      this.renderSelectedSourceFields.forEach((item, index) => {
        sources[this.alphaCounter[index]] = item;
      });
      console.log({ thispt3: sources });
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            sort: sort,
            ruleset_id: this.$route.params.id,
            rule_data: ruleData,
            source_fields: sources,
            output_type: this.output,
            mapped_param: this.newSelectedCalculatorField,
            custom_field: this.newSelectedCustomField,
          },
        }),
      };
      if (pos === "above") {
        const response = await fetch(
          config.baseURL + "/add_mapping_rule_above",
          requestOptions
        );
        const data = await response.json();
        console.log(data);

        if (data["Added"]) {
          $("#addRuleAbove" + sort).collapse("hide");
          this.rules = data["rules"];
          this.rules.forEach((element) => {
            element.source_fields = Object.values(element.source_fields);
          });
          sessionStorage.setItem("rules", JSON.stringify(data["rules"]));
          this.clear();
        } else {
          this.error = true;
          this.reason = data["reason"];
        }
      } else if (pos === "below") {
        const response = await fetch(
          config.baseURL + "/add_mapping_rule_below",
          requestOptions
        );
        const data = await response.json();
        console.log(data);

        if (data["Added"]) {
          $("#addRuleBelow" + sort).collapse("hide");
          this.rules = data["rules"];
          this.rules.forEach((element) => {
            element.source_fields = Object.values(element.source_fields);
          });
          sessionStorage.setItem("rules", JSON.stringify(data["rules"]));
          this.clear();
        } else {
          this.error = true;
          this.reason = data["reason"];
        }
      } else if (pos === "end") {
        const response = await fetch(
          config.baseURL + "/add_mapping_rule_end",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Added"]) {
          $("#addRuleEnd").collapse("hide");
          this.rules = data["rules"];
          this.rules.forEach((element) => {
            element.source_fields = Object.values(element.source_fields);
          });
          sessionStorage.setItem("rules", JSON.stringify(data["rules"]));
          this.clear();
        } else {
          this.error = true;
          this.reason = data["reason"];
        }
      }
    },
    cancelAddRuleAbove(sort) {
      $("#addRuleAbove" + sort).collapse("hide");
      this.clear();
    },
    cancelAddRuleBelow(sort) {
      $("#addRuleBelow" + sort).collapse("hide");
      this.clear();
    },
    cancelAddRuleEnd() {
      $("#addRuleEnd").collapse("hide");
      this.clear();
    },
    clear() {
      this.error = false;
      this.reason = "";
      this.qualifyFunction = "";
      this.newLookupTable = "";
      this.declineOn = "";
      this.declineMsg = "";
      this.referOnFail = false;
      this.referMsg = "";
      this.declined = "";
      this.accept = false;
      this.rows = 0;
      this.rowsEdit = 0;
      this.tableMap = {};
      // this.tableMapEdit = {};
      this.fieldValues = {};
      this.method = "";
      this.methodType = "";
      this.newSelectedSourceFields = [];
      for (var field of this.renderSelectedSourceFields.values()) {
        $("#fieldValueEnd" + field.replace(/[^a-zA-Z0-9]/g, "")).val("");
      }
      this.renderSelectedSourceFields = [];
      this.output = null;
      this.newSelectedCalculatorField = null;
      this.newSelectedCustomField = null;
      this.calculatedValue = "";
      this.executed = false;
      this.functionType = "";
      this.functionExp = "";
      this.roundType = "donotround";
      this.roundDecimals = 0;
    },
    async removeRule(rule_id) {
      if (this.confirmDeleteRule.toLowerCase() === "yes") {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              rule_id: rule_id,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_mapping_rule",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        this.rules = data["rules"];
        this.rules.forEach((element) => {
          element.source_fields = Object.values(element.source_fields);
        });
        sessionStorage.setItem("rules", JSON.stringify(data["rules"]));
        this.confirmDeleteRule = "";
      } else {
        this.confirmDeleteRule = "";
      }
    },
    async getRulesets() {
      const response = await fetch(config.baseURL + "/get_mapping_rulesets", {
        credentials: "include",
      });
      const data = await response.json();
      console.log(data);
      this.rulesets = data;
    },
    async copyRule(rule_id) {
      var rulesetId = null;
      if (this.copyType === "start" || this.copyType === "start")
        rulesetId = this.$route.params.id;
      else if (this.copyType === "another") rulesetId = this.copyRuleset;
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            rule_id: rule_id,
            ruleset_id: rulesetId,
            copy_type: this.copyType,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/copy_mapping_rule",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (
        (this.copyType !== "another" && data["Added"]) ||
        (this.copyType === "another" &&
          data["Added"] &&
          rulesetId == this.$route.params.id)
      )
        this.rules = data["rules"];
      this.rules.forEach((element) => {
        element.source_fields = Object.values(element.source_fields);
      });
      sessionStorage.setItem("rules", JSON.stringify(data["rules"]));
      if (data["Added"]) $(".toast").toast("show");
      this.copyType = "";
      this.copyRuleset = "";
    },
    clearSearch() {
      this.searchQuery = "";
      this.typeFilter = "";
      this.resultQuery = this.filterMap();
    },
    async discard() {
      if (this.confirmDelete.toLowerCase() === "yes") {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              ruleset_id: parseInt(this.$route.params.id),
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_mapping_ruleset",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Completed"]) this.$router.push("/outboundrulesets");
      } else {
        this.confirmDelete = "";
      }
    },
    async down(index) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
            swap_list: [
              {
                rule_id: this.rules[index].rule_id,
                sort: this.rules[index].sort,
              },
              {
                rule_id: this.rules[index + 1].rule_id,
                sort: this.rules[index + 1].sort,
              },
            ],
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/swap_mapping_rules_sort",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      // this.rules.splice(index, 2, this.rules[index + 1], this.rules[index]);
      this.rules = data.rules;
    },
    async up(index) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
            swap_list: [
              {
                rule_id: this.rules[index - 1].rule_id,
                sort: this.rules[index - 1].sort,
              },
              {
                rule_id: this.rules[index].rule_id,
                sort: this.rules[index].sort,
              },
            ],
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/swap_mapping_rules_sort",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      // this.rules.splice(index - 1, 2, this.rules[index], this.rules[index - 1]);
      this.rules = data.rules;
    },
    async activate() {
      if (this.active) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              ruleset_id: this.$route.params.id,
              calculator_id: this.calculator_id,
              insurer_id: this.insurer_id,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/activate_mapping_ruleset",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Activated"]) this.activated = true;
        $("#activateModal").modal("show");
      } else {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              ruleset_id: this.$route.params.id,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/deactivate_mapping_ruleset",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Deactivated"]) $("#deactivateModal").modal("show");
      }
    },
    async forceActivate() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
            calculator_id: this.calculator_id,
            insurer_id: this.insurer_id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/force_activate_mapping_ruleset",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Activated"]) {
        this.activated = true;
        $("#activateModal").modal("show");
      }
    },
    enableEdit() {
      $("#rulesetName").removeAttr("disabled");
      $("#calculatorName").removeAttr("disabled");
      $("#insurerName").removeAttr("disabled");
    },
    async updateRule(rule_id, sort) {
      var ruleData = null;

      ruleData = {
        function: this.rules[sort].rule_data.function,
        test_values: this.fieldValues,
      };
      var sources = {};
      this.rules[sort].source_fields.forEach((item, index) => {
        sources[this.alphaCounter[index]] = item;
      });
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            rule_id: rule_id,
            rule_data: ruleData,
            source_fields: sources,
            output_type: this.rules[sort].output_type,
            mapped_param: this.rules[sort].mapped_param,
            custom_field: this.rules[sort].custom_field,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/update_mapping_rule",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Added"]) {
        $("#collapse" + rule_id).collapse("hide");
        this.rules = data["rules"];
        this.rules.forEach((element) => {
          element.source_fields = Object.values(element.source_fields);
        });
        sessionStorage.setItem("rules", JSON.stringify(data["rules"]));
        $("#accordion-header" + rule_id).css({
          visibility: "visible",
          height: "auto",
        });
        this.clear();
        this.clearUpdate(rule_id, sort);
      } else {
        this.error = true;
        this.reason = data["reason"];
      }
    },
    cancelUpdateRule(rule_id, sort) {
      $("#collapse" + rule_id).collapse("hide");
      this.getDeets();
      $("#accordion-header" + rule_id).css({
        visibility: "visible",
        height: "auto",
      });
      this.fieldValues = {};
      this.calculatedValue = "";
      this.executed = false;
      this.declined = "";
      this.accept = false;
      this.error = false;
      this.reason = "";
      this.clearUpdate(rule_id, sort - 1);
    },
    clearUpdate(rule_id, sort) {
      for (var field of this.rules[sort].source_fields.values()) {
        $("#fieldValue" + field.replace(/[^a-zA-Z0-9]/g, "") + rule_id).val("");
      }
    },
    async editRuleset() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
            mapping_ruleset_name: this.ruleset_name,
            calculator_id: this.calculator_id,
            insurer_id: this.insurer_id,
            force_active: this.forceActive,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/update_mapping_ruleset",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Added"]) this.$router.push("/outboundrulesets");
      else {
        if (data["reason"].includes("active")) {
          $("#forceUpdateModal").modal("show");
        } else {
          this.updateRulesetError = true;
          this.updateRulesetReason = data["reason"];
        }
      }
    },
    async getInsurer() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            calculator_id: this.calculator_id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_single_calculator",
        requestOptions
      );
      const data = await response.json();
      this.insurer_id = data["calculator_details"]["insurer_id"];
    },
    async getCalculators() {
      this.calculator_id = null;
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_id: this.insurer_id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_calculator_using_insurer",
        requestOptions
      );
      const data = await response.json();
      this.calculators = data;
    },
    async getDeets() {
      // const requestOptions = {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   credentials: "include",
      //   body: JSON.stringify({
      //     data: {
      //       ruleset_id: this.$route.params.id,
      //     },
      //   }),
      // };
      // const response = await fetch(
      //   config.baseURL + "/get_single_mapping_ruleset",
      //   requestOptions
      // );
      // const data = await response.json();
      // console.log(data);
      // if (!data["Accepted"]) this.$router.push("/error");
      let data = JSON.parse(sessionStorage.getItem("ruleset_details"));
      this.head_ruleset_name = data["mapping_ruleset_name"];
      this.ruleset_name = data["mapping_ruleset_name"];
      this.calculator_name = data["calculator_name"];
      this.calculator_id = data["calculator_id"];
      this.insurer_name = data["insurer_name"];
      this.insurer_id = data["insurer_id"];
      this.active = data["active"];
      this.rules = JSON.parse(sessionStorage.getItem("rules"));
      // for (var rule in this.rules){
      //   this.rules[rule].source_fields=Object.values(this.rules[rule].source_fields);
      //   console.log(this.rules[rule].source_fields);
      // }
      this.rules.forEach((element) => {
        element.source_fields = Object.values(element.source_fields);
      });
      //console.log(this.rules);
      // const fres = await fetch(config.baseURL + "/get_mapping_fields", {
      //   credentials: "include",
      // });
      // const fdata = await fres.json();
      this.calculatorFields = JSON.parse(
        sessionStorage.getItem("calculator_params")
      );
      // const requestOptions1 = {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   credentials: "include",
      //   body: JSON.stringify({
      //     data: {
      //       insurer_id: this.insurer_id,
      //     },
      //   }),
      // };
      // const lres = await fetch(
      //   config.baseURL + "/get_lookup_tables_using_insurer",
      //   requestOptions1
      // );
      // const ldata = await lres.json();
      // console.log(ldata);
      this.tables = JSON.parse(
        sessionStorage.getItem("get_lookup_tables_using_insurer")
      );
      this.initialLoader = false;
    },
    async getInitialCalculators() {
      const cres = await fetch(config.baseURL + "/get_calculators", {
        credentials: "include",
      });
      const cdata = await cres.json();
      this.calculators = cdata;
    },
    async getInitialInsurers() {
      const ires = await fetch(config.baseURL + "/get_insurers", {
        credentials: "include",
      });
      const idata = await ires.json();
      this.insurers = idata;
    },
    async cacheData() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_single_mapping_ruleset",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (!data["Accepted"]) this.$router.push("/error");
      this.head_ruleset_name = data["ruleset_details"]["mapping_ruleset_name"];
      this.ruleset_name = data["ruleset_details"]["mapping_ruleset_name"];
      this.calculator_name = data["ruleset_details"]["calculator_name"];
      this.calculator_id = data["ruleset_details"]["calculator_id"];
      this.insurer_name = data["ruleset_details"]["insurer_name"];
      this.insurer_id = data["ruleset_details"]["insurer_id"];
      this.active = data["ruleset_details"]["active"];
      this.rules = data["rules"];
      this.rules.forEach((element) => {
        element.source_fields = Object.values(element.source_fields);
      });
      this.sourceLoaderArr = this.rules.map(x => { if(x) return false});
      sessionStorage.setItem(
        "ruleset_details",
        JSON.stringify(data["ruleset_details"])
      );
      sessionStorage.setItem("rules", JSON.stringify(data["rules"]));

      const fres = await fetch(config.baseURL + "/get_mapping_fields", {
        credentials: "include",
      });
      const fdata = await fres.json();
      this.calculatorFields = fdata;
      sessionStorage.setItem("calculator_params", JSON.stringify(fdata));

      const requestOptions1 = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_id: this.insurer_id,
          },
        }),
      };
      const lres = await fetch(
        config.baseURL + "/get_lookup_tables_using_insurer",
        requestOptions1
      );
      const ldata = await lres.json();
      this.tables = ldata;
      sessionStorage.setItem(
        "get_lookup_tables_using_insurer",
        JSON.stringify(ldata)
      );

      const requestOptions2 = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
          },
        }),
      };
      const qres = await fetch(
        config.baseURL + "/get_all_req_mapping_calculator_fields",
        requestOptions2
      );
      const qdata = await qres.json();
      console.log(qdata);
      sessionStorage.setItem("req_mapped_fields", JSON.stringify(qdata));
      this.initialLoader = false;
    },
  },
  mounted() {
    this.cacheData();
    // this.getDeets();
    this.getInitialCalculators();
    this.getInitialInsurers();
    // this.getLookups();
  },
};
</script>

<style scoped>
#sourceTable {
  table-layout: fixed;
  width: 100%;
}
.table-responsive {
  max-height: 300px;
}
.accordion-button::after {
  display: none;
}
.divider {
  width: 10px;
  height: auto;
  display: inline-block;
}
.spinner-border {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5%;
}
</style>
